import BaseApi from '../BaseApi';

class GameApi extends BaseApi {
  constructor(baseUrl) {
    super(baseUrl);
    this.baseUrl = `${baseUrl}/api/plinko`;
  }

  startGame = (data, token) => this.sendQuery(
    this.queryTypes.POST,
    `${this.baseUrl}/place_bet?token=${token}`,
    data,
  )
}

export default GameApi;